/*
  nn: Bundle extend — "Rozszerz paczkę" na PDP zestawu.

  Dwa custom elementy:
   - <nn-bundle-extend>  : UI na PDP (przycisk, "W paczce: …"), dane krojów, cache treści,
                           orkiestracja + przechwycenie głównego "Dodaj do koszyka"
                           (zestaw + krój jako osobne pozycje; krój z line item property).
   - <nn-be-quick-view>  : WŁASNY modal wyboru kroju. DZIEDZICZY po motywowym
                           `quick-view-modal` → reużywa show()/fetch ?section_id=quick-view/
                           init wariantów, ale ma własny, płynny hide() i skupiony panel
                           (nie kopia PDP). Motywowy #QuickView-Modal pozostaje NIETKNIĘTY:
                           izolacja przez konstrukcję, bez monkeypatcha i bramkowania.
*/

/* ── Modal: dziedziczy po quick-view-modal motywu ───────────────────────────── */
customElements.whenDefined('quick-view-modal').then(() => {
  if (customElements.get('nn-be-quick-view')) return;
  const QuickViewModal = customElements.get('quick-view-modal');

  class NnBeQuickView extends QuickViewModal {
    connectedCallback() {
      // position:fixed wymaga braku transformowanego rodzica → wychodzimy do <body>.
      if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this); // → ponowny connectedCallback (już w body)
      }
    }

    // Płynne zamknięcie: jeden szybki fade (bez motywowych 300 ms + zjazdu treści).
    // Bo to NASZA klasa, X/Esc/klik-w-tło (bindowane w ModalDialog do this.hide) używają tej wersji.
    hide(preventFocus) {
      if (preventFocus) this.openedBy = null;
      this.classList.add('closing');
      clearTimeout(this._closeTimer);
      this._closeTimer = setTimeout(() => {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        if (typeof removeTrapFocus === 'function') { try { removeTrapFocus(this.openedBy); } catch (e) {} }
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        this.classList.remove('closing');
        if (this.modalContent) this.modalContent.innerHTML = '';
      }, 240);
    }

    // Otwórz na URL kroju — reużywa odziedziczone show() (fetch + init wariantów).
    openUrl(url) {
      if (!url) return;
      this._currentUrl = url;
      if (!this._opener) {
        this._opener = document.createElement('button');
        this._opener.type = 'button';
        this._opener.style.display = 'none';
        this._opener.innerHTML = '<span class="loading-overlay__spinner hidden"></span>';
        document.body.appendChild(this._opener);
      }
      this._opener.dataset.productUrl = url;
      this.show(this._opener);
    }

    // Podmiana treści (przełączenie kroju z cache) bez ponownego otwierania.
    swapContent(html, url) {
      if (!html || !this.modalContent) return;
      this._currentUrl = url;
      if (window.HTMLUpdateUtility && typeof window.HTMLUpdateUtility.setInnerHTML === 'function') {
        window.HTMLUpdateUtility.setInnerHTML(this.modalContent, html);
        if (window.HTMLUpdateUtility.reinjectsScripts) window.HTMLUpdateUtility.reinjectsScripts(this.modalContent);
      } else {
        this.modalContent.innerHTML = html;
      }
    }
  }

  customElements.define('nn-be-quick-view', NnBeQuickView);
});

/* ── Orkiestrator: UI na PDP + dane + przechwycenie głównego add-to-cart ─────── */
if (!customElements.get('nn-bundle-extend')) {
  customElements.define(
    'nn-bundle-extend',
    class NnBundleExtend extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.trigger = this.querySelector('[data-nn-be-open]');
        // Przycisk i podgląd są w TYM SAMYM bloku — przełączają się (jeden widoczny naraz).
        this.chosen = this.querySelector('[data-nn-be-chosen]');
        this.chosenImg = this.chosen?.querySelector('[data-nn-be-chosen-img]');
        this.chosenTitle = this.chosen?.querySelector('[data-nn-be-chosen-title]');
        this.chosenVariant = this.chosen?.querySelector('[data-nn-be-chosen-variant]');
        this.chosenPrice = this.chosen?.querySelector('[data-nn-be-chosen-price]');
        this.cutInput = this.querySelector('[data-nn-be-cut-id]');
        this.addToPackageLabel = this.dataset.addToPackage || 'Dodaj do paczki';
        this.unavailableLabel = this.dataset.unavailable || 'Niedostępny';
        this.bundleIds = (this.dataset.bundleVariantIds || '').split(',').map((s) => s.trim()).filter(Boolean);
        this.bundleTitle = this.dataset.bundleTitle || '';
        this.propertyName = this.dataset.propertyName || 'Do zestawu';

        this.cuts = this.readCuts();
        this._html = {};     // url → product-info outerHTML (cache)
        this._pending = {};  // url → Promise (w locie)

        this.trigger?.addEventListener('click', () => this.open(this.defaultCutUrl()));
        this.trigger?.addEventListener('mouseenter', () => this.prefetchCuts());
        this.querySelector('[data-nn-be-change]')?.addEventListener('click', () => this.open(this._chosenUrl || this.defaultCutUrl()));
        this.querySelector('[data-nn-be-remove]')?.addEventListener('click', () => this.clearChoice());

        // Strona zestawu ma KILKA formularzy /cart/add (główny + sticky cart). Zamiast
        // wstrzykiwać do jednego, podpinamy się pod submit DOWOLNEGO i dorzucamy hidden
        // input do tego, który właśnie jest wysyłany — w fazie capture, zanim ProductForm
        // zbierze FormData. Property _nn_addon (z "_") — techniczna, ukryta wszędzie przez
        // Shopify (koszyk/checkout/mail/admin); TEST czy przechodzi przez multipart submit.
        document.addEventListener('submit', (e) => this.onSubmit(e), true);
      }

      onSubmit(e) {
        const form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        if (form.closest('nn-be-quick-view')) return;       // nasz modal — pomijamy
        if (!form.action || !form.action.includes('/cart/add')) return;
        if (!form.closest('product-info[id^="MainProduct-"]')) return; // tylko PDP zestawu

        const has = this.cutInput.value && this.cutPriceValue;
        let el = form.querySelector('input[name="properties[_nn_addon]"]');
        if (has) {
          if (!el) {
            el = document.createElement('input');
            el.type = 'hidden';
            el.name = 'properties[_nn_addon]';
            form.appendChild(el);
          }
          el.value = 'gid://shopify/ProductVariant/' + this.cutInput.value + '|' + this.cutPriceValue;
        } else if (el) {
          el.remove();
        }
      }

      get modal() { return document.getElementById('NnBeQuickView'); }

      readCuts() {
        return [...this.querySelectorAll('[data-nn-be-cut]')]
          .map((a) => ({ url: a.getAttribute('href'), type: a.getAttribute('data-type') || '', title: (a.textContent || '').trim(), img: a.getAttribute('data-img') || '' }))
          .filter((c) => c.url);
      }

      defaultCutUrl() {
        const koszulka = this.cuts.find((c) => /^koszulka/i.test(c.type));
        return (koszulka || this.cuts[0] || {}).url;
      }

      // Otwórz nasz modal (po upewnieniu się, że został zdefiniowany).
      open(url) {
        if (!url) return;
        this.prefetchCuts();
        customElements.whenDefined('nn-be-quick-view').then(() => {
          const m = this.bindModal();
          if (m && typeof m.openUrl === 'function') m.openUrl(url);
        });
      }

      // Podłącz listenery do naszego modala (raz). Submit przechwytujemy TYLKO tu.
      bindModal() {
        const m = this.modal;
        if (!m || m._nnBound) return m;
        m._nnBound = true;
        // Sami obserwujemy treść modala (każde wstrzyknięcie/przełączenie kroju → enhance).
        this._mObs = new MutationObserver(() => this.enhance(m));
        this._mObs.observe(m, { childList: true, subtree: true });
        this.enhance(m); // gdyby treść już była
        // Nasz przycisk w stopce (poza scrollem) → zapis wyboru.
        m.querySelector('[data-nn-be-submit]')?.addEventListener('click', () => this.chooseFromModal(m));
        // Submit formularza (np. Enter) też przechwytujemy — żeby nie dodało do koszyka.
        m.addEventListener('submit', (e) => {
          if (!e.target || e.target.tagName !== 'FORM') return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.chooseFromModal(m);
        }, true);
        return m;
      }

      // Wzbogacenie panelu: pasek "Inne kroje" (przycisk "Dodaj do paczki" jest w stopce, statyczny).
      enhance(m) {
        const content = m.modalContent || m.querySelector('[id^="QuickViewInfo-"]') || m;
        const form = content.querySelector('product-form, form[action*="/cart/add"]');
        if (!form) return;

        // Dostępność wariantu: motyw blokuje swój przycisk, gdy niedostępny / brak wariantu.
        const subBtn = content.querySelector('.product-form__submit');
        const subSpan = subBtn && (subBtn.querySelector('span') || subBtn);
        const variantInput = content.querySelector('[name="id"]');
        const unavailable = !variantInput || !variantInput.value ||
          (subBtn && (subBtn.hasAttribute('disabled') || subBtn.getAttribute('aria-disabled') === 'true'));
        const label = unavailable ? this.unavailableLabel : this.addToPackageLabel;

        // Desktop: oryginalny przycisk w boksie — etykieta wg dostępności (blokadę trzyma motyw).
        if (subSpan && subSpan.textContent.trim() !== label) subSpan.textContent = label;

        // Mobile: nasza stopka — etykieta + blokada.
        const footerBtn = m.querySelector('[data-nn-be-submit]');
        if (footerBtn) {
          if (footerBtn.textContent.trim() !== label) footerBtn.textContent = label;
          footerBtn.disabled = unavailable;
        }

        let strip = content.querySelector('.nn-be-strip');
        if (this.cuts.length > 1 && !strip) {
          strip = this.buildStrip(m);
          form.parentNode.insertBefore(strip, form);
        }
        if (strip) {
          strip.querySelectorAll('.nn-be-strip__tile').forEach((t) => t.classList.toggle('is-active', t.dataset.url === m._currentUrl));
          this.scrollStripActive(strip);
        }
      }

      buildStrip(m) {
        const strip = document.createElement('div');
        strip.className = 'nn-be-strip';
        const label = document.createElement('span');
        label.className = 'nn-be-strip__label';
        label.textContent = 'Inne kroje:';
        strip.appendChild(label);
        const track = document.createElement('div'); // przewijany rząd (karuzela na mobile)
        track.className = 'nn-be-strip__track';
        this.cuts.forEach((cut) => {
          const tile = document.createElement('button');
          tile.type = 'button';
          tile.className = 'nn-be-strip__tile' + (cut.url === m._currentUrl ? ' is-active' : '');
          tile.dataset.url = cut.url;
          tile.innerHTML = (cut.img ? '<img src="' + cut.img + '" alt="" loading="lazy">' : '') + '<span>' + (cut.title || 'Krój') + '</span>';
          tile.addEventListener('click', () => this.switchCut(cut.url));
          track.appendChild(tile);
        });
        strip.appendChild(track);
        return strip;
      }

      // Wycentruj aktywny kafelek w karuzeli (przewija TYLKO track, nie stronę).
      scrollStripActive(strip) {
        const track = strip && strip.querySelector('.nn-be-strip__track');
        const active = strip && strip.querySelector('.nn-be-strip__tile.is-active');
        if (!track || !active) return;
        const t = track.getBoundingClientRect();
        const a = active.getBoundingClientRect();
        const delta = (a.left + a.width / 2) - (t.left + t.width / 2);
        if (Math.abs(delta) > 1) track.scrollBy({ left: delta, behavior: 'smooth' });
      }

      switchCut(url) {
        const m = this.modal;
        if (!m || !url || url === m._currentUrl) return;
        const cached = this._html[url];
        if (cached) { m.swapContent(cached, url); return; } // enhance odpali sygnał treści
        this.fetchCut(url).then((html) => { if (html) m.swapContent(html, url); });
      }

      prefetchCuts() { this.cuts.forEach((c) => this.fetchCut(c.url)); }

      // Pobierz i scache'uj product-info dla danego kroju (z ?section_id=quick-view).
      fetchCut(url) {
        if (!url) return Promise.resolve('');
        if (this._html[url] !== undefined) return Promise.resolve(this._html[url]);
        if (this._pending[url]) return this._pending[url];
        const p = fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-view')
          .then((r) => r.text())
          .then((t) => {
            const pi = new DOMParser().parseFromString(t, 'text/html').querySelector('product-info[id^="ProductQuickView-"]');
            const out = pi ? pi.outerHTML : '';
            this._html[url] = out;
            delete this._pending[url];
            return out;
          })
          .catch(() => { this._html[url] = ''; delete this._pending[url]; return ''; });
        this._pending[url] = p;
        return p;
      }

      // Wybór w naszym modalu → zapis wyboru (NIE dodaje do koszyka) + zamknięcie.
      chooseFromModal(m) {
        const content = m.modalContent || m.querySelector('[id^="QuickViewInfo-"]') || m;
        const variantId = content?.querySelector('[name="id"]')?.value;
        if (!variantId) return;
        const subBtn = content.querySelector('.product-form__submit');
        if (subBtn && (subBtn.hasAttribute('disabled') || subBtn.getAttribute('aria-disabled') === 'true')) return; // niedostępny

        // Tytuł: w quick view .product__title ma (opcjonalny) link vendora (.product__vendor-link,
        // np. "Przez nikiniki") + link nazwy produktu. Bierzemy nazwę — pomijamy link vendora.
        const titleEl = content.querySelector('.product__title a:not(.product__vendor-link)') ||
          content.querySelector('.product__title h1, .product__title h2') ||
          content.querySelector('.product__title');
        const title = (titleEl?.textContent || '').trim();

        // Zdjęcie aktywnego wariantu.
        const imgEl = content.querySelector('.product__media-item.is-active img') ||
          content.querySelector('.product__media-list img, .product__media img');
        const imgSrc = imgEl ? this.thumbUrl(imgEl.currentSrc || imgEl.src) : '';

        // Cena bieżącego wariantu.
        const priceEl = content.querySelector('.price-item--sale:not([hidden]):not(.hidden), .price-item--regular, .price-item');
        const price = (priceEl?.textContent || '').replace(/\s+/g, ' ').trim();

        // Wybrane opcje wariantu (kolor / rozmiar / kolor nadruku) — jak w koszyku.
        const variant = this.readChosenOptions(content);

        this.cutInput.value = variantId;
        this.cutPriceValue = this.parsePrice(price);
        this._chosenUrl = m._currentUrl;
        this.renderChosen({ title, imgSrc, price, variant });
        if (this.chosen) {
          this.chosen.hidden = false;
          if (this.trigger) this.trigger.hidden = true;
        }
        m.hide();
      }

      // Czytelne wartości wybranych opcji (kolor / rozmiar / kolor nadruku) z zaznaczonych
      // pickerów — bo data-selected-variant JSON nie aktualizuje się po zmianie opcji.
      // Zwraca np. "Jasnoszary melanż / XL / Czerwony".
      readChosenOptions(content) {
        const out = [];
        content.querySelectorAll('.product-form__input--variant-picker').forEach((picker) => {
          const radio = picker.querySelector('input[type="radio"]:checked');
          if (radio) { const v = (radio.value || '').trim(); if (v) out.push(v); return; }
          const sel = picker.querySelector('select');
          if (sel) { const v = (sel.value || '').trim(); if (v) out.push(v); }
        });
        return out.join(' / ');
      }

      renderChosen({ title, imgSrc, price, variant }) {
        if (this.chosenImg) {
          if (imgSrc) { this.chosenImg.src = imgSrc; this.chosenImg.hidden = false; }
          else { this.chosenImg.removeAttribute('src'); this.chosenImg.hidden = true; }
        }
        if (this.chosenTitle) this.chosenTitle.textContent = title || '';
        if (this.chosenVariant) this.chosenVariant.textContent = variant || '';
        if (this.chosenPrice) this.chosenPrice.textContent = price || '';
      }

      // Mniejsza wersja zdjęcia z Shopify CDN (szerokość 240) do miniatury karty.
      thumbUrl(url) {
        if (!url) return '';
        if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=240');
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }

      // Parsuje wyświetlaną cenę ("75,65 zł", "1 234,56 zł") na liczbę "75.65".
      parsePrice(str) {
        if (!str) return '';
        var s = String(str).replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
        var n = parseFloat(s);
        return isFinite(n) ? n.toFixed(2) : '';
      }

      clearChoice() {
        this.cutInput.value = '';
        this.cutPriceValue = '';
        this._chosenUrl = null;
        if (this.chosen) this.chosen.hidden = true;
        this.renderChosen({ title: '', imgSrc: '', price: '', variant: '' });
        if (this.trigger) this.trigger.hidden = false;
      }
    }
  );
}
